import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import congthuong from "~/assets/logo/congthuong.webp";
import "./style.css";

const SYSTEMS_FOOTER = [
  { title: 'ERP Mini', path: '/erpMini' },
  { title: 'CRM', path: '/crm' },
  { title: 'DMS', path: '/dms' },
  { title: 'HRM', path: '/hrm' },
  { title: 'PM', path: '/pm' },
  { title: 'PMS', path: '/pms' },
  { title: 'MES', path: '/mes' },
  { title: 'TMS', path: '/tms' },
  { title: 'WMS', path: '/wms' },
  { title: 'EAM', path: '/eam' },
  { title: 'APExLINK', path: 'https://apexlink.dev/', isExternal: true },
  { title: 'AI B2B Platform', path: 'https://platform.apetechs.co/', isExternal: true },
];

const MainFooter = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('footer');

  const CATEGORIES = [
    { title: t('categories.news'), path: '/blog' },
    { title: t('categories.library'), path: '/library' },
    { title: t('categories.terms'), path: '/terms-service' },
    { title: t('categories.privacy'), path: '/privacy-policy' },
  ];

  const handleNav = (path: string, isExternal?: boolean) => {
    if (isExternal) {
      window.open(path, "_blank", "noopener noreferrer");
    } else {
      navigate(path);
    }
  };

  return (
    <footer className="dev-footer">
      <div className="dev-footer-inner">
        <div className="dev-footer-grid">
          {/* Brand Column */}
          <div>
            <div className="dev-footer-logo" onClick={() => navigate("/")}>
              <span className="dev-footer-logo-prefix">&gt;_</span>
              <span>APETECHS</span>
            </div>
            <p className="dev-footer-tagline">
              {t('tagline')}
            </p>
            <div className="dev-footer-dkkd">
              {t('dkkd')}&nbsp;<strong style={{ color: "#94A3B8" }}>0316600532</strong><br />
              {t('dkkd_by')}<br />
              {t('dkkd_date')}
            </div>
          </div>

          {/* Systems Column */}
          <div>
            <div className="dev-footer-col-title">{t('col_systems')}</div>
            <div className="dev-footer-links">
              {SYSTEMS_FOOTER.map((sys) => (
                <span
                  key={sys.title}
                  className="dev-footer-link"
                  onClick={() => handleNav(sys.path, sys.isExternal)}
                >
                  {sys.title}
                </span>
              ))}
            </div>
          </div>

          {/* Categories Column */}
          <div>
            <div className="dev-footer-col-title">{t('col_categories')}</div>
            <div className="dev-footer-links">
              {CATEGORIES.map((cat) => (
                <span
                  key={cat.path}
                  className="dev-footer-link"
                  onClick={() => navigate(cat.path)}
                >
                  {cat.title}
                </span>
              ))}
            </div>
          </div>

          {/* Contact Column */}
          <div>
            <div className="dev-footer-col-title">{t('col_contact')}</div>

            <div className="dev-footer-contact-row">
              <div className="dev-footer-contact-icon">📞</div>
              <div className="dev-footer-contact-text">
                <a href="tel:0987183484">0987 183 484</a>
              </div>
            </div>

            <div className="dev-footer-contact-row">
              <div className="dev-footer-contact-icon">✉</div>
              <div className="dev-footer-contact-text">
                <a href="mailto:dat.nguyen@apetechs.com">dat.nguyen@apetechs.com</a>
                <br />
                <a href="mailto:info@apetechs.com">info@apetechs.com</a>
              </div>
            </div>

            <div className="dev-footer-contact-row">
              <div className="dev-footer-contact-icon">📍</div>
              <div className="dev-footer-contact-text">
                <a
                  href="https://maps.app.goo.gl/95NVBE38PzmBMVcU8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  66 đường D, LakeView City,<br />
                  P. Bình Trưng, TP. HCM
                </a>
              </div>
            </div>

            {/* Socials */}
            <div className="dev-footer-socials">
              <a
                href="https://www.facebook.com/apetechsolutions"
                target="_blank"
                rel="noopener noreferrer"
                className="dev-footer-social-btn"
                title="Facebook"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/apetechsolutions"
                target="_blank"
                rel="noopener noreferrer"
                className="dev-footer-social-btn"
                title="LinkedIn"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@apetechsolutions"
                target="_blank"
                rel="noopener noreferrer"
                className="dev-footer-social-btn"
                title="YouTube"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.97C5.12 20 12 20 12 20s6.88 0 8.59-.45a2.78 2.78 0 0 0 1.95-1.97A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
                  <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#0C0C0C" />
                </svg>
              </a>
              <a
                href="https://zalo.me/0929748866"
                target="_blank"
                rel="noopener noreferrer"
                className="dev-footer-social-btn"
                title="Zalo"
              >
                <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "-0.03em" }}>Zalo</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div className="dev-footer-bottom">
          <div className="dev-footer-copyright">
            {t('copyright')}{" "}
            <a href="https://apetechs.com/" target="_blank" rel="noopener noreferrer">
              Apetechs
            </a>
            . All rights reserved.
          </div>
          <div className="dev-footer-congthuong">
            <a href="http://online.gov.vn/Home/WebDetails/85378" target="_blank" rel="noopener noreferrer">
              <img src={congthuong} alt="Đã thông báo Bộ Công Thương" style={{ height: 40, opacity: 0.7 }} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;
